import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  return (
    <Link 
      to="/" 
      className={`logo-container ${className}`}
      aria-label="BuildZap - Home"
    >
      <div className="logo-wrapper">
        <img 
          src="/images/logo.jpg" 
          alt="BuildZap Logo" 
          className="logo-image"
        />
      </div>
    </Link>
  );
};

export default Logo;
